<template>
  <div class="update-credit-card-button" v-on:click="openUpdateCreditCardPopup">
    <div class="button-title">
      <span class="text">כרטיס לחיוב</span>
      <span class="card-number">{{ formattedCardNumberMask }}</span>
    </div>
    <div class="edit">
      <img :src="require('@/assets/pencil.svg')" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UpdateCreditCardHandler from '../UpdateCreditCardHandler.vue';

export default {
  name: 'UpdateCreditCardButton',
  mixins: [UpdateCreditCardHandler],
  async created() {
    this.startContentLoading(this.$options.name);
    await this.fetch();
    this.doneContentLoading(this.$options.name);
  },
  computed: {
    ...mapState('creditCardDetails', ['cardNumberMask']),
    formattedCardNumberMask() {
      if (this.cardNumberMask) {
        const lastFourDigits = this.cardNumberMask.slice(-4);
        return `**** **** **** ${lastFourDigits}`;
      }
      return null;
    },
  },
  methods: {
    ...mapActions('creditCardDetails', ['fetch']),
    ...mapActions('contentLoader', ['startContentLoading', 'doneContentLoading']),
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../../../../node_modules/base-ui/src/scss/riseup-colors";

  .update-credit-card-button {
    height: 98px;
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .button-title {
      display: flex;
      flex-direction: column;
      line-height: 1.5;
      color: $riseup_black;

      .text {
        font-size: 14px;
        font-family: SimplerPro;
      }

      .card-number {
        direction: ltr;
        font-size: 20px;
        font-weight: bold;
        font-family: SimplerProBold;
      }
    }

    .button-icon {
      color: $riseup_black;
    }

    .edit {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
</style>
